if (!customElements.get('vet-card-readmore')) {
  customElements.define(
    'vet-card-readmore',
    class VetCardReadmore extends HTMLElement {
      connectedCallback() {
        this.textEl = this.querySelector('[data-vet-text]');
        this.btn = this.querySelector('[data-readmore-btn]');
        this.labelMore = this.querySelector('[data-label-more]');
        this.labelLess = this.querySelector('[data-label-less]');
        if (!this.textEl || !this.btn) return;

        this.expanded = false;
        this._onResize = this._debounce(() => {
          if (this._isMobile() && this.expanded) return;
          this._measure();
        }, 150);

        this.btn.addEventListener('click', () => this.toggle());
        window.addEventListener('resize', this._onResize);

        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this._measure());
        } else {
          requestAnimationFrame(() => this._measure());
        }
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this._onResize);
      }

      _debounce(fn, ms) {
        let t;
        return (...args) => {
          clearTimeout(t);
          t = setTimeout(() => fn.apply(this, args), ms);
        };
      }

      _isMobile() {
        return typeof window.matchMedia !== 'undefined' && window.matchMedia('(max-width: 749px)').matches;
      }

      _resetDesktop() {
        this.textEl.classList.remove('product__vet-card-text--collapsed');
        this.btn.hidden = true;
        this.btn.classList.remove('product__vet-card-readmore-btn--expanded');
        this.expanded = false;
        this.btn.setAttribute('aria-expanded', 'false');
        if (this.labelMore && this.labelLess) {
          this.labelMore.classList.remove('hidden');
          this.labelLess.classList.add('hidden');
        }
      }

      _measure() {
        if (!this.textEl) return;

        if (!this._isMobile()) {
          this._resetDesktop();
          return;
        }

        this.textEl.classList.add('product__vet-card-text--collapsed');
        this.btn.hidden = true;

        requestAnimationFrame(() => {
          if (!this._isMobile()) {
            this._resetDesktop();
            return;
          }
          const overflow = this.textEl.scrollHeight > this.textEl.clientHeight + 2;
          if (overflow) {
            this.btn.hidden = false;
            this.btn.setAttribute('aria-expanded', 'false');
          } else {
            this.textEl.classList.remove('product__vet-card-text--collapsed');
            this.btn.hidden = true;
          }
        });
      }

      toggle() {
        if (!this._isMobile()) return;
        this.expanded = !this.expanded;
        this.textEl.classList.toggle('product__vet-card-text--collapsed', !this.expanded);
        this.btn.classList.toggle('product__vet-card-readmore-btn--expanded', this.expanded);
        this.btn.setAttribute('aria-expanded', this.expanded ? 'true' : 'false');

        if (this.labelMore && this.labelLess) {
          this.labelMore.classList.toggle('hidden', this.expanded);
          this.labelLess.classList.toggle('hidden', !this.expanded);
        }
      }
    }
  );
}
